import React from 'react'
import { counterData } from '../data/data'
import CountUp from 'react-countup'

export default function Counter() {
    return (
        <>
            <div className="row justify-content-center">
                {counterData.map((item, index) => {
                    let Icon = item.icon
                    return (
                        <div className="col-md-4 col-12 mt-4" key={index}>
                            <div className="p-4 rounded bg-white shadow-lg">
                                <div className="counter-box text-center">
                                    <div className="position-relative d-flex justify-content-center">
                                        <Icon className="fea icon-lg text-primary" />
                                    </div>
                                    <h3 className="mb-0 text-dark fw-semibold"><CountUp end={item.value} />{item.posttitle}</h3>
                                    <h6 className="counter-head text-muted fw-medium mb-0">{item.title}</h6>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </>
    )
}
